import {useEffect} from "react";
import {AppActions, useAppContext} from "../../context/AppContext";

export const disableSelectKeyboard = () => {
    window.disabledSelectKeyboard = 'none'
}

export const enableSelectKeyboard = () => {
    window.disabledSelectKeyboard = 'enabled'
}

const getSelectKeyboardDisabled = () => {
    if(!window.disabledSelectKeyboard || window.disabledSelectKeyboard === 'enabled')
        return false

    return true
}

export default function () {
    const {appContext, dispatchProject, getSelectedHistory, selectedHistoryId, getHistorySorted} = useAppContext()

    useEffect(() => {
        const keyUp = (e) => {
            if(document.activeElement.tagName === 'INPUT')
                return

            const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
            if(keys.includes(e.key)) {
                let numIndex = parseInt(e.key)
                if(numIndex === 0)
                    numIndex = 10

                const selectedHistory = getHistorySorted()?.find(x => x.id === selectedHistoryId)
                if(selectedHistory?.type === 'Check') {
                    const _histories = getHistorySorted()?.filter(x => x.type === 'Check')
                    if(numIndex-1 < _histories.length) {
                        dispatchProject({
                            type: AppActions.SET_SELECTED_HISTORY_ID,
                            data: {id: _histories[numIndex-1]?.id}
                        })
                    }
                }
                else if(selectedHistory?.type === 'Comparison') {
                    const _histories = getHistorySorted()?.filter(x => x.type === 'Comparison')
                    if(numIndex-1 < _histories.length) {
                        dispatchProject({
                            type: AppActions.SET_SELECTED_HISTORY_ID,
                            data: {id: _histories[numIndex-1]?.id}
                        })
                    }
                }
            }
        }

        window.addEventListener('keyup', keyUp);

        return () => {
            window.removeEventListener('keyup', keyUp)
        }
    }, [selectedHistoryId]);

    return (
        <></>
    )
}